function waitForChildren(target, func){
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
              func();
              observer.disconnect()
              break;
            }
      }});

      observer.observe(target, { childList: true, subtree: true });
}

function onRemove(element, onDetachCallback) {
    const observer = new MutationObserver(function () {
        if (!document.contains(element)) {
            observer.disconnect();
            onDetachCallback();
        }
    })

    observer.observe(document.body, {
         childList: true,
         subtree: true
    });
}

customElements.whenDefined('addi-product-widget').then(() => {
    const w = document.getElementsByTagName("addi-product-widget")[0]
    if(w !== null){
      addStyle()
      onRemove(w, function(){addStyle()})
    }
});

function addStyle() {
  console.log("style injected into addi widget!")
      const w = document.getElementsByTagName("addi-product-widget")[0]
      var shadowRoot = w.shadowRoot;
      onRemove(w, function(){addStyle()})
      waitForChildren(shadowRoot, function(){
        let bannerRoot = shadowRoot.querySelector("addi-product-banner").shadowRoot
        waitForChildren(bannerRoot, function(){
          var style = document.createElement('style');
          css = 
            `addi-product-banner{
              width:100%;
              display: block;
            }`
          shadowRoot.prepend(style);
          style.type = 'text/css';
          if (style.styleSheet){
            style.styleSheet.cssText = css;
          } else {
            style.appendChild(document.createTextNode(css));
          }
          bannerRoot.querySelector("style").innerHTML = 
            `.addi-banner-custom {
                  font-family: Inter, system-ui;
                  border-color: rgb(235, 236, 237);
                  border-radius: 20px;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
                  border: 2px rgb(50,50,100) solid !important;
                  background-color: rgb(78 126 255);
                  transition: 0.5s;
                  padding: 7px;
                  margin-top: 5px;
                  &:hover{
                    background-color: #18181f;
                  }
              }

              div{
                width: 100% !important;
                box-sizing: border-box !important;
              }

              .addi-banner--with-discount {
                  border-radius: 0 5px 5px 5px;
              }
              
              .addi-banner-custom-bagde {
                  background-color: transparent;
                  max-width: 38px !important;
              }
              
              .addi-banner-custom-info {
                  font-size: 12px;
                  color: #fff !important;
                  transition: 0.2s ease-in-out;
                  background: transparent;
              }
              
              .addi-banner-custom-discount {
                  font-size: 12px;
              }
              
              .addi-banner-bagde__icon--filled{filter: invert(1) grayscale(1) brightness(2)}
              
              .addi-banner-button--link{color: #ffcf3a !important}
              
              .addi-banner-info__addi-logo{filter: brightness(3) saturate(0) contrast(2)}
              
              .addi-banner-wrapper{margin: -5px 0 5px 0}

              `
        })
      })
}